"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFile = readFile;
exports.getCroppedImg = getCroppedImg;
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

// Polyfills for IE/Edge/...
require('blueimp-canvas-to-blob');

function readFile(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.addEventListener('load', function () {
      return resolve(reader.result);
    }, false);
    reader.readAsDataURL(file);
  });
}

var createImage = function createImage(url) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.addEventListener('load', function () {
      return resolve(image);
    });
    image.addEventListener('error', function (error) {
      return reject(error);
    });
    image.src = url;
  });
};

function getCroppedImg(_x, _x2, _x3) {
  return _getCroppedImg.apply(this, arguments);
}
/**
 * Export functions for mock purposes
 */


function _getCroppedImg() {
  _getCroppedImg = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(imageSrc, pixelCrop, resized) {
    var image, canvas, maxWidth, maxHeight, ratio, ctx;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createImage(imageSrc);

          case 2:
            image = _context.sent;
            canvas = document.createElement('canvas');
            maxWidth = 1000;
            maxHeight = 750;

            if (resized) {
              maxWidth = 200;
              maxHeight = 150;
            }

            ratio = 1;

            if (pixelCrop.width > maxWidth) {
              ratio = maxWidth / pixelCrop.width;
            }

            if (pixelCrop.height > maxHeight && ratio < maxHeight / pixelCrop.height) {
              ratio = maxHeight / pixelCrop.height;
            }

            canvas.width = pixelCrop.width * ratio;
            canvas.height = pixelCrop.height * ratio;
            ctx = canvas.getContext('2d');
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, canvas.width, canvas.height); // As a blob

            return _context.abrupt("return", new Promise(function (resolve) {
              canvas.toBlob(function (file) {
                resolve(file);
              }, 'image/jpeg', 0.7);
            }));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getCroppedImg.apply(this, arguments);
}

var imageUtils = {
  readFile: readFile,
  getCroppedImg: getCroppedImg
};
var _default = imageUtils;
exports.default = _default;
//# sourceMappingURL=imageUtils.js.map